import React, { PropsWithChildren } from 'react';
import ButtonBase from './ButtonBase';

interface ButtonDeleteProps {
  onClick: CallableFunction;
  disabled?: boolean;
  rounded?: boolean;
  className?: string;
  outline?: boolean;
}

const ButtonDelete = ({
  children,
  onClick = () => {},
  disabled = false,
  rounded = false,
  className,
  outline = false

}: PropsWithChildren<ButtonDeleteProps>) => {

  const handleClick = () => onClick();

  return (
    <ButtonBase 
      onClick={handleClick}
      disabled={disabled}
      rounded={rounded}
      className={`
        ${className} text-red-500
        ${outline ? 'ring-red-100 hover:ring-red-200 bg-none hover:bg-red-50/50' : 'ring-transparent bg-red-50/50 hover:bg-red-50'}
    `}>
      {children}
    </ButtonBase>
  )
}

export default ButtonDelete;